import { useMutation, useQuery } from "react-query";
import { EvaluationQuestionService } from "./evaluationQuestionService";

export const useCreateEvaluationQuestion = () =>
  useMutation({
    mutationFn: EvaluationQuestionService.create,
  });

export const useQuestionsByForm = (formId) =>
  useQuery({
    queryKey: ["questions-by-form", formId],
    queryFn: () => EvaluationQuestionService.getByForm(formId),
    enabled: !!formId,
    select: (res) => res.data,
  });

export const useGroupedQuestions = (formId) =>
  useQuery({
    queryKey: ["grouped-questions", formId],
    queryFn: () => EvaluationQuestionService.getGroupedByForm(formId),
    enabled: !!formId,
    select: (res) => res.data,
  });
export const useUpdateEvaluationQuestion = () =>
  useMutation({
    mutationFn: ({ id, ...data }) => EvaluationQuestionService.update(id, data),
  });
export const useDeleteEvaluationQuestion = () =>
  useMutation({
    mutationFn: EvaluationQuestionService.remove,
  });
export const useSkillsList = (options) =>
  useQuery({
    queryKey: ["skills", options],
    queryFn: async () => {
      const response = await EvaluationQuestionService.getSkillsList(options);
      return response.data;
    },
  });
